import { sectionMargin } from 'common/components/page-section';
import { css } from 'linaria';

export const productQualityDocumentsWrapper = css`
  margin-top: var(--space-500);

  @media (--only-mobile) {
    margin-top: var(--space-200);
  }

  .pimDisclaimerWrapper + & {
    @media (--from-tablet) {
      margin-top: 0;
    }
  }

  ul {
    padding: 0;
  }
`;

export const fileTextIconWrapper = css`
  padding: var(--space-85);
  border-radius: var(--rounding-m);
  border: 1px solid var(--control-minor);
`;

export const listItem = css`
  padding-top: var(--space-125);
  padding-bottom: var(--space-125);
  padding-left: var(--space-300);

  @media (--from-tablet) {
    padding-left: var(--space-100);
  }

  li {
    column-gap: var(--space-150);
  }
`;

export const divider = css`
  margin: ${sectionMargin}px 0;

  @media (--only-mobile) {
    margin: ${sectionMargin}px 0 0;
    border: none !important;
  }
`;
